import React from 'react'

export const Status = () => {
  return (
    <div className='bg-[#F0F0F0] px-4 py-3 rounded-lg my-4 dark:bg-[#282828] '>
    <p className='opacity-60'>Uploading Now</p>
    <div className='flex items-center justify-between'>
        <div className='flex items-center space-x-4 my-4'>

        <img className='w-14' src="https://cdn.dribbble.com/userupload/13596860/file/original-22c9315324246484358dde3b6b64863e.png?resize=752x564" alt="" />
        <div>
            <h1>Creato Neobrutalism...</h1>
            <p className='opacity-60'>Web Template</p>
        </div>
        </div>
        <button className='bg-[#D3D3D3] px-4 py-2 rounded-lg dark:bg-[#5B5B5B] dark:text-white'>Draft</button>
    </div>
   
</div>
  )
}
